import {
  EXPERT_APPLICATION_STATUSES,
  EXPERT_STATUSES,
} from '@admin/constants/general'
import { BADGE_VARIANTS } from 'components/Badge'
import { ZOOM_ACCOUNT_TYPE } from 'constants/common'
import { type StatusBadgeMapper } from './types'

export const EXPERT_ZOOM_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  [ZOOM_ACCOUNT_TYPE.BASIC]: {
    variant: BADGE_VARIANTS.ORANGE,
  },
  [ZOOM_ACCOUNT_TYPE.LICENCED]: {
    variant: BADGE_VARIANTS.GREEN,
  },
  [ZOOM_ACCOUNT_TYPE.ON_PREM]: {
    variant: BADGE_VARIANTS.GREEN,
  },
} as const

export const EXPERT_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  [EXPERT_STATUSES.ACTIVE]: {
    variant: BADGE_VARIANTS.GREEN,
  },
  [EXPERT_STATUSES.SUSPENDED]: {
    variant: BADGE_VARIANTS.RED,
  },
} as const

export const EXPERT_APPLICATION_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  [EXPERT_APPLICATION_STATUSES.PENDING]: {
    variant: BADGE_VARIANTS.BLUE,
  },
  [EXPERT_APPLICATION_STATUSES.IN_WAITLIST]: {
    variant: BADGE_VARIANTS.BROWN,
  },
  [EXPERT_APPLICATION_STATUSES.APPROVED]: {
    variant: BADGE_VARIANTS.GREEN,
  },
  [EXPERT_APPLICATION_STATUSES.REJECTED]: {
    variant: BADGE_VARIANTS.RED,
  },
} as const

export const USER_REFERRAL_STATUS_BADGE_VALUES: StatusBadgeMapper = {
  'Invitation sent': {
    variant: BADGE_VARIANTS.BLUE,
  },
  'Reward earned': {
    variant: BADGE_VARIANTS.GREEN,
  },
  Cancelled: {
    variant: BADGE_VARIANTS.GRAY,
  },
} as const

export const INVENTORY_SYNC_LOG_BADGE_VALUES: StatusBadgeMapper = {
  INFO: {
    variant: BADGE_VARIANTS.BLUE,
  },
  ERROR: {
    variant: BADGE_VARIANTS.RED,
  },
  WARNING: {
    variant: BADGE_VARIANTS.ORANGE,
  },
} as const

export const INVENTORY_SYNC_LOG_ERROR_BADGE_VALUES: StatusBadgeMapper = {
  No: {
    variant: BADGE_VARIANTS.BLUE,
  },
  Yes: {
    variant: BADGE_VARIANTS.RED,
  },
} as const

export const INVENTORY_SYNC_LOG_TYPE_BADGE_VALUES: StatusBadgeMapper = {
  PRIMARY: {
    variant: BADGE_VARIANTS.BLUE,
  },
  SECONDARY: {
    variant: BADGE_VARIANTS.ORANGE,
  },
  SHOPIFY: {
    variant: BADGE_VARIANTS.GREEN,
  },
}

export const INVENTORY_SYNC_LOG_RUN_TYPE_BADGE_VALUES: StatusBadgeMapper = {
  PUBLISHING_RUN: {
    variant: BADGE_VARIANTS.BLUE,
  },
  DRY_RUN: {
    variant: BADGE_VARIANTS.ORANGE,
  },
}
